export default class Iterator {
    // Public:
    constructor(array) {
        this._array = array;
        this._nElements = array.length;
        this._initialIndex = 0;
        this._isDiagonal = false;
        this.reset();
    }

    next() {
        if (this.hasFinished()) {
            this.reset();
            if (this.hasParent()) this.advanceParent();
        } else {
            this._index++;
            if (this.hasChild() && this.isDiagonal()) this.setChildInitialIndexAsParent();
        }
    }

    hasFinished() {
        if (this._index < this._nElements) return false;
        else return true;
    }

    getValue() {
        const array = this._array;
        const index = this._index;
        return array[index];
    }

    getIndex() {
        return this._index;
    }

    reset() {
        const initialIndex = this._initialIndex;
        this.setIndex(initialIndex);
        if (this.hasChild() && this.isDiagonal()) this.setChildInitialIndexAsParent();
    }

    setIndex(index) {
        this._index = index;
    }

    setInitialIndex(index) {
        this._initialIndex = index;
        this.reset();
    }

    setParent(parent) {
        this._parent = parent;
    }

    setChild(child) {
        this._child = child;
    }

    setAsDiagonal() {
        this._isDiagonal = true;
    }

    //Private:
    advanceParent() {
        let parent = this._parent;
        parent.next();
    }

    setChildInitialIndexAsParent() {
        const index = this.getIndex();
        this._child.setInitialIndex(index);
    }

    hasParent() {
        if (this._parent !== undefined) return true;
        else return false;
    }

    hasChild() {
        if (this._child !== undefined) return true;
        else return false;
    }

    isDiagonal() {
        return this._isDiagonal;
    }
}
